import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab } from './SL00000Sprint00'
import { basicSlide, orderedListSlide, tPrework, tRecap, sprintDemosIntro, sprintDemos } from './SLSprint00'

import { retrospectiveBreakout, retrospectiveIntroduction } from './SLSprint00'
import { submissionPercentage } from './SLSprint00'
import { demoAssignment } from './SLSprint00'

import { holiday } from './SL20000Sprint01'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'
import { tUnderConstruction } from './SL00000Sprint00'
import { aa_4_1of1_PAaA } from './SL62100Sprint04'

import { tDiscussionBreakout } from './SLSprint00'
import { tMidtermExamExpectations, tExam } from './SLSprint00'

// import { list61200Sprint02 } from '../ActivityLists/AL61200Sprint02'
//import { list61200Sprint03 } from '../ActivityLists/AL61200Sprint03'
import { list61200Sprint05 } from '../ActivityLists/AL61200Sprint05'
// Software Architecture (SA) module 3 / sprint 3 global values.
const sprint = 5
const activityList = () => { return list61200Sprint05(sprint) }

export const aa_3_1of1_PAaA = {
	'prework':[
		`All sprint ${sprint-1} activities and assignments due Sunday!`, '',
		`Be prepared for Sprint ${sprint-1} Demos and Retrospective`,
		`Be prepared for Sprint ${sprint} Planning and Discussion ${sprint}`,
		'Be prepared for Midterm Exam... to start no later than 4:45' ],
	'announcements':[ 
		'Welcome back!', '',
		'Only three class sessions remaining after today', 
		`Let’s stay focused on bringing closure to Sprint ${sprint-1} and completing Sprint ${sprint} Planning` ],
	'agenda':[
		`Sprint ${sprint-1} Demos and Retrospective`,
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		`Discussion Board ${sprint} as a Scrum Team`,
		'Lab',
		'Recap',
		'Midterm Exam / Quiz 5' ]
}

const sprint_xx_class_1 = (activityList, xyz_2_1of1_PAaA, xyz_3_1of1Prework) => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:12, submitted:11 },
			{ name: 'Quiz', due:12, submitted:11 },
			{ name: 'Lab', due:12, submitted:11 },
			{ name: 'Reflection', due:12, submitted:11 }])
	}

	const retrospectiveInto = () => { return retrospectiveIntroduction(sprint)}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			'Okay job getting everything submitted “on time”... quite a few late postings and submissions',
			`Thank you for your Reflection ${sprint-1} comments`,
			'I really appreciated the music suggestions',
			'Several issues with attaching documents to assignments',
			'Very nice initial architecture designs submitted',
			'One consistently element missing in the architecture designs... CI/CD implementation for development and unit testing was missing',
			'I am substantially ahead on grading with most grades already posted... Go Eric!' ])
	}

	const breakout = () =>{ return retrospectiveBreakout(sprint) }

	const sprintPlanning = () => {
		return orderedListSlide(`Sprint ${sprint} Planning`, `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'We will complete our scrum team Discussion Board breakout session today',
			`We will have sprint ${sprint} Demos and Retrospective today`,
			'Midterm Exam / Quiz 5 will be today' ])
		
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list and assignments together.' ]
		)
	}
	const shortBreak = () => {
		return basicSlide('Break', [
			'Let’s take a 5 minute break.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review Sprint ${sprint} activity list & assignments in detail`,
			'Discuss and identify questions/concerns',
			'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns' ]
		)
	}

	const discussionBreakout = () => { return tDiscussionBreakout(sprint) }

	const recap = () => { return tRecap(xyz_2_1of1_PAaA.agenda.slice(1))}

	const examExpectations = () => { return tMidtermExamExpectations(sprint) }
	const exam = () => { return tExam(sprint) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_2_1of1_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', xyz_3_1of1Prework, sprint, activityList) }
	return completeDeck(slideDeck, [ sprintDemosIntro, sprintDemos, demoAssignment, retrospectiveInto, 
		metricsSubmissionPercentage, retrospective, breakout, shortBreak, sprintPlanning, activitiesReview, 
		planningBreakout, discussionBreakout, tLab,preworkNext, recap, examExpectations, exam ])
}

const aa_3_1of1 = () => { return sprint_xx_class_1(activityList, aa_3_1of1_PAaA, aa_4_1of1_PAaA.prework) }

const aa_3_2of1 = () => { return [ tUnderConstruction, holiday, renderCalendar, renderFinalExamTimes ] }

export const aa_3_slidedeck = [ aa_3_1of1, aa_3_2of1 ]